import React, { memo } from 'react'
import { Formik, Form } from 'formik'
import { Button, Grid, TextField } from '@material-ui/core'
import FormField from '../../components/FormField'
import HttpHandler from '../../shared/services/httpHandler'
import Dialog from '../../components/Dialog'
import PhoneTextField from '../PhoneTextField'
import validationSchema from './validationSchema'
import * as Styled from './styled'
import { CUSTOMER } from '../../shared/constants/interestedList'

const CustomLivesFormDialog = ({ open, onCancel, isDesk }) => {
  const handleSubmit = async (values, resetFields) => {
    const payload = { ...values, type: 1 }
    try {
      if (payload.name) {
        await new HttpHandler('/register').post(payload)
        resetFields()
        onCancel()
      }
    } catch (error) {
      onCancel()
    }
  }

  return (
    <Dialog
      isDesk={isDesk}
      title="Planos com condições especiais mais de 99 vidas"
      onClose={onCancel}
      open={open}
    >
      <Formik
        onSubmit={handleSubmit}
        initialValues={{ name: '', email: '', phoneNumber: '', interestedIn: CUSTOMER }}
        validationSchema={validationSchema}
        validationOnChange={false}
      >
        {({ values, errors, ...formikProps }) => (
          <Form>
            <Grid container spacing={2} direction={'column'}>
              <Grid item xs={12}>
                <Styled.Text variant="body1">
                  Preencha o formulário abaixo para receber a cotação para mais de 99 vidas.
                </Styled.Text>
              </Grid>

              <Grid item xs={12}>
                <FormField
                  fullWidth
                  variant='outlined'
                  label='Seu nome'
                  name='name'
                  component={TextField}
                />
              </Grid>

              <Grid item xs={12}>
                <FormField
                  type='email'
                  fullWidth
                  variant='outlined'
                  label='Seu email'
                  name='email'
                  component={TextField}
                />
              </Grid>

              <Grid item xs={12}>
                <FormField
                  fullWidth
                  name='phoneNumber'
                  label='Seu celular'
                  variant='outlined'
                  onBlur={event => {
                    formikProps.handleBlur(event)
                    formikProps.setFieldTouched('phoneNumber', true)
                  }}
                  component={PhoneTextField}
                />
              </Grid>

              <Grid
                item
                xs={12}
                align='center'
                style={{ padding: 0, marginTop: '18px' }}
              >
                <Button
                  fullWidth
                  type='submit'
                  color='primary'
                  variant='contained'
                  aria-label='Pedir cotação'
                  type="submit"
                >
                  Pedir cotação
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default memo(CustomLivesFormDialog)
